import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const RSVP = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    guests: '1',
    attending: 'yes',
    message: ''
  });

  const [showPopup, setShowPopup] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  
    try {
      // For Google Apps Script, use 'no-cors' mode
      await fetch('https://script.google.com/macros/s/AKfycbzXvNrltkwGAVpEPSVtn2tutBl0V7VhS5R-8dayX2AJINRvVFtohYU4u6FbzGuqU_9Sxg/exec', {
        method: 'POST',
        mode: 'no-cors', // ← Important for Google Apps Script
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
  
      // With 'no-cors', we can't check response.ok
      // So we assume success if no error is thrown
      setShowPopup(true);
      setFormData({ name: '', email: '', phone: '', guests: '1', attending: 'yes', message: '' });
      
      // Auto-close popup after 5 seconds
      setTimeout(() => {
        setShowPopup(false);
      }, 5000);
  
    } catch (error) {
      alert('Error submitting RSVP. Please try again.');
      console.error('Error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <section id="rsvp" className="py-32 bg-gradient-to-b from-white to-wedding-blush relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-2xl relative z-10">
        
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl md:text-6xl font-serif text-wedding-accent mb-4">
            RSVP
          </h2>
          <div className="flex items-center justify-center gap-3 mb-6">
            <div className="w-16 h-[1px] bg-wedding-primary"></div>
            <div className="w-2 h-2 bg-wedding-primary rounded-full"></div>
            <div className="w-16 h-[1px] bg-wedding-primary"></div>
          </div>
          <p className="text-wedding-charcoal/60 text-lg">
            We'd love to have you celebrate with us
          </p>
        </motion.div>

        {/* Form */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-4 border-wedding-accent/10"
        >
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Full Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wedding-primary focus:border-transparent transition-all"
                placeholder="Praful Jain"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Email Address <span className="text-red-500">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wedding-primary focus:border-transparent transition-all"
                placeholder="rahul@example.com"
              />
            </div>

            {/* Phone */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Phone Number
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wedding-primary focus:border-transparent transition-all"
                placeholder="+91 98765 43210"
              />
            </div>

            {/* Number of Guests */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Number of Guests <span className="text-red-500">*</span>
              </label>
              <select
                name="guests"
                value={formData.guests}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wedding-primary focus:border-transparent transition-all"
              >
                <option value="1">1 Guest</option>
                <option value="2">2 Guests</option>
                <option value="3">3 Guests</option>
                <option value="4">4 Guests</option>
                <option value="5">5+ Guests</option>
              </select>
            </div>

            {/* Attending */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Will you attend? <span className="text-red-500">*</span>
              </label>
              <select
                name="attending"
                value={formData.attending}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wedding-primary focus:border-transparent transition-all"
              >
                <option value="yes">Yes, I'll be there! 🎉</option>
                <option value="no">Sorry, can't make it 😔</option>
                <option value="maybe">Maybe</option>
              </select>
            </div>

            {/* Message */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Special Message (Optional)
              </label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-wedding-primary focus:border-transparent transition-all resize-none"
                placeholder="Any dietary restrictions, song requests, or special messages?"
              ></textarea>
            </div>

            {/* Submit Button */}
            <motion.button
              type="submit"
              disabled={isSubmitting}
              className={`w-full bg-wedding-accent hover:bg-wedding-primary text-white font-semibold py-4 rounded-lg transition-all duration-300 uppercase tracking-wider ${
                isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              whileHover={!isSubmitting ? { scale: 1.02 } : {}}
              whileTap={!isSubmitting ? { scale: 0.98 } : {}}
            >
              {isSubmitting ? 'Submitting...' : 'Submit RSVP'}
            </motion.button>
          </form>
        </motion.div>
      </div>

      {/* SUCCESS POPUP MODAL - WEDDING THEMED */}
      <AnimatePresence>
        {showPopup && (
          <>
            {/* Backdrop */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
              onClick={() => setShowPopup(false)}
            >
              {/* Popup Card */}
              <motion.div
                initial={{ scale: 0, rotate: -10 }}
                animate={{ scale: 1, rotate: 0 }}
                exit={{ scale: 0, rotate: 10 }}
                transition={{ type: "spring", duration: 0.5 }}
                className="bg-white rounded-3xl shadow-2xl max-w-md w-full p-8 md:p-12 text-center relative overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Decorative Background Pattern */}
                <div className="absolute inset-0 opacity-5">
                  <div className="absolute inset-0" style={{
                    backgroundImage: 'radial-gradient(circle, #C9A581 1px, transparent 1px)',
                    backgroundSize: '30px 30px'
                  }}></div>
                </div>

                {/* Confetti Animation */}
                <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
                  {[...Array(20)].map((_, i) => (
                    <motion.div
                      key={i}
                      className="absolute w-2 h-2 bg-wedding-primary rounded-full"
                      initial={{ 
                        x: Math.random() * 100 + '%',
                        y: -20,
                        opacity: 1 
                      }}
                      animate={{ 
                        y: '120%',
                        opacity: 0,
                        rotate: 360
                      }}
                      transition={{ 
                        duration: 2 + Math.random() * 2,
                        delay: Math.random() * 0.5,
                        repeat: Infinity
                      }}
                      style={{ 
                        left: `${Math.random() * 100}%`,
                        backgroundColor: ['#F4C2C2', '#C9A581', '#8B7355'][Math.floor(Math.random() * 3)]
                      }}
                    />
                  ))}
                </div>

                {/* Content */}
                <div className="relative z-10">
                  {/* Animated Rings Icon */}
                  <motion.div
                    initial={{ rotate: -20, scale: 0 }}
                    animate={{ rotate: 0, scale: 1 }}
                    transition={{ delay: 0.2, type: "spring" }}
                    className="text-8xl mb-4"
                  >
                    💍
                  </motion.div>

                  {/* Success Message */}
                  <motion.h3
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                    className="text-3xl md:text-4xl font-serif text-wedding-accent mb-3"
                  >
                    Thank You!
                  </motion.h3>

                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                  >
                    <p className="text-lg text-gray-700 mb-2">
                      Your RSVP has been received! ✨
                    </p>
                    <p className="text-gray-600 mb-6">
                      We can't wait to celebrate with you!
                    </p>

                    {/* Decorative Divider */}
                    <div className="flex items-center justify-center gap-3 mb-6">
                      <div className="w-12 h-[1px] bg-wedding-accent/30"></div>
                      <span className="text-2xl">💐</span>
                      <div className="w-12 h-[1px] bg-wedding-accent/30"></div>
                    </div>

                    {/* Close Button */}
                    <motion.button
                      onClick={() => setShowPopup(false)}
                      className="bg-wedding-accent hover:bg-wedding-primary text-white font-semibold px-8 py-3 rounded-lg transition-colors duration-300 uppercase tracking-wider text-sm"
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      Close
                    </motion.button>
                  </motion.div>
                </div>

                {/* Decorative Corner Elements */}
                <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-wedding-accent/20 rounded-tl-3xl"></div>
                <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-wedding-accent/20 rounded-br-3xl"></div>
              </motion.div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </section>
  );
};

export default RSVP;
